<template>
  <section class="news">
    <div class="cover news">
      <h2>お知らせ</h2>
    </div>

    <ul class="breadcrumb">
      <li><router-link to="/">ホーム</router-link></li>
      <li>お知らせ</li>
    </ul>

    <div :class="{ loading: !news, loaded: news }"><img src="@/assets/img/spinner.svg" class="spinner"></div>

    <ul class="news-list">
      <NewsListItem v-for="item in news" :key="item.id" :item="item" />
    </ul>

  </section>
</template>

<script>
import NewsListItem from '@/components/NewsListItem.vue'

export default {
  name: 'NewsView',
  components: {
    NewsListItem,
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/common.scss';

.news-list {
  @include sp {
    margin: 24px auto 40px auto;
  }
}
</style>
